import ShowTimesPage from 'pages/ShowTimesPage/ShowTimesPage'

export default ShowTimesPage
